import { render, staticRenderFns } from "./EditAccountProfile.vue?vue&type=template&id=482bae50&scoped=true&lang=pug&"
import script from "./EditAccountProfile.vue?vue&type=script&lang=ts&"
export * from "./EditAccountProfile.vue?vue&type=script&lang=ts&"
import style0 from "./EditAccountProfile.vue?vue&type=style&index=0&id=482bae50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482bae50",
  null
  
)

export default component.exports